






  import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
  import AbpBase from "../../../lib/abpbase";
  let echarts = require("echarts");
  require("echarts/lib/chart/line");
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");
  class SelSeriesData{
    locationName:string;
    mac:string;
    mac1:string;
    mac2:string;
    mac3:string;
    pageid:Number=0;
  }
  @Component
  export default class Echarts extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({type:String}) legenddata:string;
    @Prop({type:String}) xAxisdata:string;
    @Prop({type:String}) seriesdata:string;
    @Prop({type:String}) strtitle:string;
    @Prop({type:String}) yAxisdata:string;
    @Prop({type:String}) locationName:string;
    @Prop({type:String}) mac:string;
    @Prop({type:String}) mac1:string;
    @Prop({type:String}) mac2:string;
    @Prop({type:String}) mac3:string;
    @Prop({type:String}) pageid:Number;
    selseriesdata: SelSeriesData = new SelSeriesData();
    option = {
    title: {
        text: ''
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: []
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    toolbox: {
        feature: {
            saveAsImage: {},
            myTool1: {
              show: true,
              title: '保存为Excel',
              icon: 'path://M695.168 311.168a42.624 42.624 0 0 1 60.330667 0l170.666666 170.666667c1.194667 1.194667 2.346667 2.517333 3.413334 3.84l0.682666 0.896a32.085333 32.085333 0 0 1 2.133334 3.2c0.298667 0.512 0.64 1.024 0.896 1.578666a49.536 49.536 0 0 1 2.261333 4.821334l0.938667 2.56 0.597333 1.962666 0.682667 2.773334 0.384 2.218666A38.229333 38.229333 0 0 1 938.666667 512l-0.170667-3.669333a20.864 20.864 0 0 1 0.128 2.304L938.666667 512l-0.042667 1.450667-0.128 2.218666a53.461333 53.461333 0 0 1-0.298667 2.730667l-0.384 2.218667c-0.170667 0.938667-0.426667 1.877333-0.64 2.773333a26.368 26.368 0 0 1-0.597333 1.962667c-0.256 0.853333-0.597333 1.664-0.896 2.517333a34.858667 34.858667 0 0 1-2.304 4.821333l-0.896 1.536a40.874667 40.874667 0 0 1-6.272 7.936l3.413333-3.84-0.298666 0.384-3.114667 3.498667-170.666667 170.666667a42.624 42.624 0 1 1-60.330666-60.330667L792.96 554.666667H384a42.666667 42.666667 0 0 1-42.368-37.674667L341.333333 512a42.666667 42.666667 0 0 1 42.666667-42.666667h408.96l-97.792-97.834666a42.666667 42.666667 0 0 1-3.541333-56.32l3.541333-4.010667zM426.666667 42.666667a42.666667 42.666667 0 0 1 0 85.333333H213.333333a42.666667 42.666667 0 0 0-42.666666 42.666667v682.666666a42.666667 42.666667 0 0 0 42.666666 42.666667h213.333334a42.666667 42.666667 0 0 1 0 85.333333H213.333333a128 128 0 0 1-128-128V170.666667a128 128 0 0 1 128-128h213.333334z',
              onclick: () => {
                console.log(this.option);
                var axisData = this.option.xAxis.data;
                var series = this.option.series;
                var legent = this.option.legend.data;
                let str = '位置：,'+this.selseriesdata.locationName+',SN号：,'+this.selseriesdata.mac + '\n,';
                for(let i = 0;i < legent.length;i++){
                  str+=legent[i]+',';
                }
                str+='\n';
                if(this.selseriesdata.pageid==0){
                  str+=','+this.selseriesdata.mac1 + ',' + this.selseriesdata.mac2 + ',' + this.selseriesdata.mac3 + '\n';
                }
                for(let i = 0; i < axisData.length; i++){
                  str += axisData[i] + ',';
                  for(let j = 0;j < legent.length;j++){
                    str+=series[j].data[i] + ','
                  }
                  str+='\n';
                }
                let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
                let link = document.createElement("a");
                link.href = uri;
                link.download = this.selseriesdata.locationName + "&" + this.selseriesdata.mac +".csv";
                link.click();
                URL.revokeObjectURL(link.href);
              }
            },
            dataView:{}
        }
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value'
    },
    series: [
    ]
};

    drawLine() {
      var myChart = echarts.init(this.$el);
      myChart.setOption(this.option);
    }

    mounted() {
      if(this.seriesdata!=""){
       //console.log(this.strtitle+"123");
       this.option.legend.data=JSON.parse(this.legenddata);
       this.option.xAxis.data=JSON.parse(this.xAxisdata);
      this.option.series=JSON.parse(this.seriesdata);
      //保存数据
      if(this.locationName!=undefined){
        this.selseriesdata.locationName = this.locationName;
      }
      if(this.mac!=undefined){
        this.selseriesdata.mac = this.mac;
      }
      if(this.mac1!=undefined){
        this.selseriesdata.mac1 = this.mac1;
      }
      if(this.mac2!=undefined){
        this.selseriesdata.mac2 = this.mac2;
      }
      if(this.mac3!=undefined){
        this.selseriesdata.mac3 = this.mac3;
      }
      this.selseriesdata.pageid = this.pageid;
      this.option.title.text=this.strtitle;
      }
      this.drawLine();
    }
  }
